/**
 * Séquence 2 — Formation à la conduite hors circulation (1 h min)
 *
 * Travaille : équipements, découverte du véhicule, contrôles avant départ,
 * maîtrise (position, démarrage, arrêt, freinage, virages, évitement).
 */
export const sequence2 = {
  officiel: {
    equipements: {
      description:
        "Le référentiel prévoit une adaptation à l'option quadricycle. Ici uniquement les équipements applicables à la voiturette.",
      items: [
        { key: 'vetements',   label: 'Vêtements adaptés',         desc: 'Confortables, ne gênant pas les manipulations.' },
        { key: 'intemperies', label: 'Protection intempéries',    desc: 'Vêtement chaud/impermeable selon météo — confort et vigilance.' },
        { key: 'visibilite',  label: 'Visibilité',                desc: "Être visible : éviter les vêtements totalement sombres surtout la nuit." },
        { key: 'ceinture',    label: 'Ceinture de sécurité',       desc: 'OBLIGATOIRE pour la voiturette (conducteur ET passager).', flag: 'obligatoire' },
      ],
    },
    decouverteVehicule: {
      description: "L'élève doit connaître les principaux organes et savoir effectuer les contrôles nécessaires à l'entretien et à la sécurité.",
      items: [
        'Tableau de bord — compteurs, voyants, témoins',
        'Éclairage — fonctionnement de tous les feux',
        'Freins — fonctionnement et test avant départ',
        'Pneumatiques — usure, pression',
        'Batterie — témoins de charge, contact',
        'Carburant — niveau, ou charge électrique',
        'Présignalisation en cas de panne — triangle, gilet',
      ],
    },
    maitrise: {
      description: 'Travail sur zone fermée avant tout déplacement en circulation.',
      items: [
        'Position de conduite — réglage du siège',
        'Réglage du volant',
        'Réglage des rétroviseurs',
        'Mise en marche · démarrage',
        "Arrêt · ralentissement · immobilisation",
        'Freinage progressif et freinage d’urgence',
        'Virages',
        'Demi-tours',
        'Importance du regard',
        "Évitement (réaction à un obstacle imprévu)",
      ],
    },
  },
  enrichi: {
    checklistDepart: [
      { key: 'pneus',       label: 'Pneus',                      desc: 'Aspect général · pas de crevaison · pression correcte.' },
      { key: 'eclairage',   label: 'Éclairage',                  desc: 'Feux avant / arrière / stop / clignotants OK.' },
      { key: 'retros',      label: 'Rétroviseurs',               desc: 'Réglés de manière à voir la voie derrière.' },
      { key: 'parebrise',   label: 'Pare-brise · visibilité',    desc: 'Propre · essuie-glaces fonctionnels.' },
      { key: 'ceinture',    label: 'Ceinture',                   desc: 'Bouclée conducteur + passager.' },
      { key: 'carburant',   label: 'Carburant / charge',         desc: 'Niveau suffisant pour ton parcours.' },
      { key: 'voyants',     label: 'Voyants',                    desc: "Aucun voyant d'alerte allumé au démarrage." },
      { key: 'commandes',   label: 'Commandes',                  desc: "Pédales, sélecteur, avertisseur : tout répond." },
      { key: 'environnement', label: 'Environnement',            desc: 'Rien devant/derrière, aucun piéton, aucun obstacle.' },
    ],
    niveauxMaitrise: [
      { niveau: 1, label: 'Je découvre',     desc: "Je nomme les commandes et je les identifie." },
      { niveau: 2, label: 'Je manipule',    desc: 'Je les utilise en zone fermée avec accompagnement.' },
      { niveau: 3, label: 'Je maîtrise',    desc: 'Je réalise les exercices seul, régulièrement.' },
      { niveau: 4, label: 'Je suis autonome', desc: 'Je peux enseigner un geste à quelqu’un d’autre.' },
    ],
    focusVoiturette: [
      "Contrairement au scooter, tu conduis assis, ceinturé, avec un volant — tes gestes ressemblent à ceux d'une voiture.",
      'Ta vitesse est limitée à 45 km/h par construction : cela influence toutes tes décisions de circulation.',
      "Ton gabarit réduit peut te rendre moins visible pour les autres usagers — anticiper est vital.",
    ],
  },
};

export default sequence2;
